import React, { useState, useContext } from 'react'
import StoreContext from '../../../context/StoreContext'
import styled from 'styled-components'

 const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr ;
  padding: 2rem 0 2rem 0;
  grid-gap:2em;

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr ;
  }

  img {
   max-width:100%;
  }
`

const QuantityContain = styled.div`
  display: grid;
  grid-template-columns: 35px 25px 40px;
  align-items: center;


 
`

const AddRemoveItems = styled.div`
  border: none;
  outline: none;
  text-align: center;
  margin-top: 5px;
`

const QuantityButton = styled.div`
  cursor: pointer;
  border: 1px solid;
  padding: 4px 10px;
  display: block;
  position: relative;
  text-align: center;
  transition: all 0.3s ease 0s;
  background: white;
  

  &:hover {
    background: ${props => props.theme.primarycolor};
    color: white;
  }
`

const RemoveItem = styled.button`
  background: none;
  border: 1px solid ${props => props.theme.primarycolor};
  padding: 6px;
  cursor: pointer;
  transition: all 0.3s ease 0s;
  background: white;
  color: ${props => props.theme.primarycolor};
  max-height: 86px;
  max-width: 140px;
  align-self: center;

  &:hover {
    background: ${props => props.theme.primarycolor};
    color: white;
  }
`


const LineItem = props => {
  const { line_item } = props
  const [quantity, setQuantity] = useState(line_item.quantity)
  const {
    removeLineItem, 
    updateLineItem,
    store: { client, checkout },
  } = useContext(StoreContext)


  const variantImage = line_item.variant.image ? (
    <img
      src={line_item.variant.image.src}
      alt={`${line_item.title} product shot`}
    />
  ) : null

  const selectedOptions = line_item.variant.selectedOptions
    ? line_item.variant.selectedOptions.map(
        option => `${option.name}: ${option.value} `
      )
    : null

  const handleRemove = () => {
    removeLineItem(client, checkout.id, line_item.id)
  }


  const handleQuantityChange = ({ target }) => {
    setQuantity(target.value)
      updateLineItem(client, checkout.id, line_item.id, target.value)
    }
  


  const decreaseItem = () => {
    
    if(quantity > 1) {
      updateLineItem(client, checkout.id, line_item.id, line_item.quantity - 1)
    }else {
      return null 
  }
}

  const increaseItem = () => {
    if(quantity < 8) {
      updateLineItem(client, checkout.id, line_item.id, line_item.quantity + 1)
    }else {
      return null 
  }
}

  return (
    <Wrapper>
      {variantImage}
      <div>
      <p>
        {line_item.title}
       
      </p>
      
      
      </div>
      
      <QuantityContain>
    
        <QuantityButton onClick={decreaseItem}>-</QuantityButton>
        <AddRemoveItems
          id="quantity"
          name="quantity"
          min="1"
          step="1"
          value={line_item.quantity}
          onChange={handleQuantityChange}
        >
          {line_item.quantity}
        </AddRemoveItems>
        <QuantityButton onClick={increaseItem}>+</QuantityButton>
      </QuantityContain>
      <RemoveItem 
        onClick={handleRemove}>
        Remove
      </RemoveItem>
    </Wrapper>
  )
}

export default LineItem
